import { type CompanyStore } from "services/company/companyStore";
import { type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { CompanyNameQuestion } from "./companyNameConstants";

export class CompanyNameAcnQuestionsStore extends QuestionsStore<CompanyNameQuestion> {
  constructor(
    private readonly _companyStore: CompanyStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(CompanyNameQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): CompanyNameQuestion | undefined {
    const { company } = this._companyStore;

    if (!company?.companyName) {
      return CompanyNameQuestion.Name;
    }

    return undefined;
  }
}
